import axios, {
  isAxiosError,
  type AxiosInstance,
  type AxiosRequestConfig,
  type AxiosResponse,
} from 'axios'

// import getStoredToken from "./getStoredToken";

// Create a pre-configured Axios instance
const axiosInstance: AxiosInstance = axios.create({
  baseURL: '/api',
})

// axiosInstance.interceptors.request.use(
//   config => {
//     if (config.method?.toLocaleUpperCase() === "POST") {
//       const walletAddress = config.data?.wallet_address as string;
//       const storedToken = getStoredToken(walletAddress);

//       if (storedToken) {
//         config.headers = AxiosHeaders.concat(config.headers, {
//           // Send token as a plain string instead of JSON
//           Authorization: `Bearer ${storedToken.signin_token}`,
//           "Wallet-Address": storedToken.wallet_address,
//         });
//       }
//     }
//     return config;
//   },
//   error => Promise.reject(error),
// );

// // Add response interceptor for centralized error handling
// axiosInstance.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response?.status === 401) {
//       // Handle unauthorized - clear tokens
//       // localStorage.removeItem("storedToken");
//       // Optionally redirect to login or dispatch an action
//       // window.location.href = '/';
//     }
//     return Promise.reject(error);
//   },
// );

// API Request Utility
export const apiRequest = async <T, D = any>(
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET',
  data?: D,
  headers?: Record<string, string>
): Promise<AxiosResponse<T>> => {
  const config: AxiosRequestConfig = {
    url,
    method,
    data,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  }

  try {
    const response: AxiosResponse<T> = await axiosInstance(config)
    return response
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Request failed')
    } else {
      throw new Error('Unexpected error occurred')
    }
  }
}

export default axiosInstance
